import moment from 'moment';

const EMPTY_DATE_VALUES = ['', '0', null, undefined];

export const parseApiDate = (value) => {
    if (EMPTY_DATE_VALUES.includes(value)) return null;
    const parsed = moment(value, ['YYYY-MM-DD', 'DD-MMM-YYYY', moment.ISO_8601], true);
    if (!parsed.isValid() || parsed.year() <= 1900) return null;
    return parsed.toDate();
};

export const toApiDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);

export const emptyToNull = (value) => {
    const trimmed = (value === null || value === undefined ? '' : `${value}`).trim();
    return trimmed === '' ? null : trimmed;
};

export const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#F5F5F5' : null,
        color: '#000',
        ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
    }),
};

export const getSelectedFinancialYear = () => {
    try {
        const saved = JSON.parse(localStorage.getItem('selectedFinancialYear'));
        if (saved?.id) return saved.id;
        const years = JSON.parse(localStorage.getItem('financialYear')) || [];
        const active = years.find((fy) => fy.isActive);
        return active?.id || '';
    } catch (error) {
        return '';
    }
};

// Best effort: the server is the source of truth, so an unknown year simply skips the client-side check.
export const getFinancialYearRange = (financialYear) => {
    try {
        const years = JSON.parse(localStorage.getItem('financialYear')) || [];
        const fy = years.find((y) => `${y.id}` === `${financialYear}`);
        const from = parseApiDate(fy?.startDate ?? fy?.fromDate ?? fy?.start);
        const to = parseApiDate(fy?.endDate ?? fy?.toDate ?? fy?.end);
        return from && to ? { from, to, label: financialYear } : null;
    } catch (error) {
        return null;
    }
};

export const toOptions = (list, labelOf = (item) => item.text) =>
    (list || []).map((item) => ({ value: item.value, label: labelOf(item), raw: item }));
